import { AfterViewInit, Directive, ElementRef, inject, input, OnDestroy } from '@angular/core';
import { ElementMaxHeightService } from '@common/services';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  selector: '[appTrackHeight]'
})
export class TrackHeightDirective implements AfterViewInit, OnDestroy {
  private readonly el = inject(ElementRef);
  private readonly heightService = inject(ElementMaxHeightService);

  public readonly key = input.required<string>({ alias: 'appTrackHeight' });

  ngAfterViewInit(): void {
    const key = this.key();

    if (key) {
      this.heightService.updateRef(key, this.el.nativeElement);
    }
  }

  ngOnDestroy(): void {
    const key = this.key();

    if (key) {
      this.heightService.updateRef(key, null);
    }
  }
}
